import React from 'react';
import './index.css';
import { NavLink } from 'react-router-dom';

const Error404 = () => {
  return (
    <>
        <div id='notfound'>
            <div className="notfound">
                <div className="notfound-404">
                    <h1>404</h1>
                </div>
                <h2>WE ARE SORRY, PAGE NOT FOUUND</h2>
                <p>THE PAGE YOU ARE LOOKING FOR MIGHT HAVE BEEN REMOVED HAD ITS NAME CHANGED OR IS TEMPORARILY UNAVAILABLE.</p>
                <NavLink to="/" className=' btn btn-info text-light mt-5' style={{borderRadius:'20px',fontSize:'2rem'}}>Back to Homepage</NavLink>
            </div>
        </div>
    </>
  )
}

export default Error404;